import styled from "styled-components";

export const UsersContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const NameCell = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;

/** Single-line ellipsis for long role lists; full text in Tooltip. */
export const RoleTextTruncated = styled.span`
  display: inline-block;
  max-width: min(240px, 28vw);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
`;

